<template>
  <el-dialog
    class="rc-dialog"
    :title="title"
    :visible.sync="isShow"
    :close-on-click-modal="false"
    @close="handleClose"
    width="500px"
  >
    <el-form
      ref="editForm"
      :model="editObject"
      size="small"
      :rules="rules"
      label-width="20px"
      class="form"
    >
      <el-row>
        <el-col>
          <el-form-item>
            <el-input
              v-model="editObject.keyWords"
              placeholder="请输入热搜词"
              maxlength="15"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom()" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="submitForm()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus";
import rulesFactory from "@/utils/rules";
import { hotSave, hotUpdate } from "@/api/hotSearch";

export default {
  name: "curd",
  components: { butn },
  data() {
    return {
      isShow: false,
      title: "",
      editObject: {
        uuid: "",
        keyWords: "",
      },
      rules: {
        keyWords: [rulesFactory.required("请输入热搜词")],
      },
    };
  },
  methods: {
    closeFrom() {
      this.$refs["editForm"].resetFields();
      this.isShow = false;
      this.dragaable = false;
      // 点击取消 数据重置
    },
    handleClose() {
      this.$refs["editForm"].resetFields();
      this.editObject = {
        keyWords: "",
      };
    },
    showFrom(msg) {
      this.isShow = true;
      this.title = msg;
    },
    submitForm() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          if (!this.editObject.uuid) {
            // 新增
            hotSave(this.editObject).then((res) => {
              if (!res || res.code != 0) return;
              // Bus.$emit("reload");
              this.$emit("search");
            });
          } else {
            //编辑
            hotUpdate(this.editObject).then((res) => {
              if (!res || res.code != 0) return;
              // Bus.$emit("reload");
              this.$emit("search");
            });
          }
          this.closeFrom();
        }
      });
    },
  },
  created() {
    Bus.$on("addHot", () => {
      this.showFrom("添加热搜词");
    });
    Bus.$on("updateHot", (row) => {
      this.editObject.keyWords = row.keyWords;
      this.editObject.uuid = row.uuid;
      this.showFrom("编辑热搜词");
    });
  },
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .form {
    .el-form-item {
      margin-bottom: 0;
    }
    .el-form-item--small.el-form-item {
      margin: 0;
    }
  }
}
</style
>>
